import * as less from './Shop.less';
import React from 'react';
import classnames from 'classnames';
import WindowResizeComponent from '../components/WindowResizeComponent';
import rockersHat from '../assets/images/shop/rockers-hat.png';
import rockersDisk from '../assets/images/shop/rockers.jpg';
import ppuHat from '../assets/images/shop/ppu-hat.png';
import ppuDisk from '../assets/images/shop/ppu.jpg';
import golfChannelHat from '../assets/images/shop/golf-channel-hat.png';
import golfChannelDisk from '../assets/images/shop/golf-channel.jpg';
import foundationHat from '../assets/images/shop/foundation-hat.png';
import foundationDisk from '../assets/images/shop/foundation.jpg';
import burgerHat from '../assets/images/shop/burger-hat.png';
import burgerDisk from '../assets/images/shop/burger.jpg';
import stonesThrowHat from '../assets/images/shop/stones-throw-hat.png';
import stonesThrowDisk from '../assets/images/shop/stones-throw.jpg';
import workshopHat from '../assets/images/shop/workshop-hat.png';
import workshopDisk from '../assets/images/shop/workshop.jpg';
import minimalWaveHat from '../assets/images/shop/minimal-wave-hat.png';
import minimalWaveDisk from '../assets/images/shop/minimal-wave.jpg';
import plantHat from '../assets/images/shop/plant-hat.png';
import plantDisk from '../assets/images/shop/plant.jpg';
import soundwayHat from '../assets/images/shop/soundway-hat.png';
import soundwayDisk from '../assets/images/shop/soundway.jpg';
import productLinks from '../playlists/product-links';

export default class Shop extends WindowResizeComponent() {
  createCallClick(label) {
    return (e) => {
      e.preventDefault();

      this.props.actions.play(label);
    };
  }

  render() {
    const territory = 'en';
    const minPanelHeight = 600;

    let panelStyle = {};

    if (this.state.windowWidth >= 768) {
      panelStyle = {
        height: this.state.windowHeight < minPanelHeight ? minPanelHeight : this.state.windowHeight
      };
    }

    const rockersClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'rockers'
    });

    const ppuClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'ppu'
    });

    const golfChannelClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'golf-channel'
    });

    const foundationClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'foundation'
    });

    const burgerClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'burger'
    });

    const stonesThrowClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'stones-throw'
    });

    const workshopClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'workshop'
    });

    const minimalWaveClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'minimal-wave'
    });

    const plantClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'plant'
    });

    const soundwayClassNames = classnames('call-out dark solid call-out-description', {
      'display-onair': this.props.playlist.isPlaying && this.props.playlist.playlist.key === 'soundway'
    });

    return (
      <div className='page-shop-container'>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('rockers')} className={rockersClassNames}>
            <span className='title'>Rockers Intl</span>
            <span className='subtitle'>—Reggae</span>
            <span className='more-info'>Kingston</span>
            <span className='onair'>—on air</span>
          </a>

          <a href='http://www.kangolstore.com' target='_blank' className='browse-kangol'>Browse all Kangol hats</a>

          <div className='rockers-hat-container'>
            <div className='rockers-hat-image'>
              <a href={productLinks.rockers.hat[territory]} target='_blank'><img src={rockersHat} /></a>
            </div>
            <a href={productLinks.rockers.hat[territory]} target='_blank' className='call-out dark rockers-hat-call-out'>
              <span className='title'>Digi Marble</span>
              <span className='title'>Casual Black</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='rockers-disk-container'>
            <div className='rockers-disk-image'>
              <a href={productLinks.rockers.disk} target='_blank'><img src={rockersDisk} width='335' /></a>
            </div>
            <a href={productLinks.rockers.disk} target='_blank' className='call-out dark rockers-disk-call-out'>
              <span className='title'>King David's</span>
              <span className='title'>Melody</span>
              <span className='title'>—Augustus</span>
              <span className='title'>Pablo—Buy</span>
            </a>
          </div>
        </div>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('ppu')} className={ppuClassNames}>
            <span className='title'>PPU Records</span>
            <span className='subtitle'>—Funk/Soul</span>
            <span className='more-info'>DC</span>
            <span className='onair'>—on air</span>
          </a>

          <div className='ppu-hat-container'>
            <div className='ppu-hat-image'>
              <a href={productLinks.ppu.hat[territory]} target='_blank'><img src={ppuHat} width='552' /></a>
            </div>
            <a href={productLinks.ppu.hat[territory]} target='_blank' className='call-out dark ppu-hat-call-out'>
              <span className='title'>TROPIC VENTAIR</span>
              <span className='title'>504 NAVY</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='ppu-disk-container'>
            <div className='ppu-disk-image'>
              <a href={productLinks.ppu.disk} target='_blank'><img src={ppuDisk} width='335' /></a>
            </div>
            <a href={productLinks.ppu.disk} target='_blank' className='call-out dark ppu-disk-call-out'>
              <span className='title'>born with—</span>
              <span className='title'>a desire</span>
              <span className='title'>tony palkovic</span>
              <span className='title'>—Buy</span>
            </a>
          </div>
        </div>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('golf-channel')} className={golfChannelClassNames}>
            <span className='title'>Golf Channel</span>
            <span className='subtitle'>—House</span>
            <span className='more-info'>NYC</span>
            <span className='onair'>—on air</span>
          </a>

          <div className='golf-channel-hat-container'>
            <div className='golf-channel-hat-image'>
              <a href={productLinks['golf-channel'].hat[territory]} target='_blank'><img src={golfChannelHat} width='552' /></a>
            </div>
            <a href={productLinks['golf-channel'].hat[territory]} target='_blank' className='call-out dark golf-channel-hat-call-out'>
              <span className='title'>MARKER PEN</span>
              <span className='title'>REVERSIBLE</span>
              <span className='title'>BUCKET</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='golf-channel-disk-container'>
            <div className='golf-channel-disk-image'>
              <a href={productLinks['golf-channel'].disk} target='_blank'><img src={golfChannelDisk} width='335' /></a>
            </div>
            <a href={productLinks['golf-channel'].disk} target='_blank' className='call-out dark golf-channel-disk-call-out'>
              <span className='title'>paradise—</span>
              <span className='title'>payfone</span>
              <span className='title'>—Buy</span>
            </a>
          </div>
        </div>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('foundation')} className={foundationClassNames}>
            <span className='title'>Foundation</span>
            <span className='subtitle'>—Experimental</span>
            <span className='more-info'>Seoul</span>
            <span className='onair'>—on air</span>
          </a>

          <div className='foundation-hat-container'>
            <div className='foundation-hat-image'>
              <a href={productLinks.foundation.hat[territory]} target='_blank'><img src={foundationHat} width='552' /></a>
            </div>
            <a href={productLinks.foundation.hat[territory]} target='_blank' className='call-out dark foundation-hat-call-out'>
              <span className='title'>tropic</span>
              <span className='title'>bombin WHITE</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='foundation-disk-container'>
            <div className='foundation-disk-image'>
              <a href={productLinks.foundation.disk} target='_blank'><img src={foundationDisk} width='335' /></a>
            </div>
            <a href={productLinks.foundation.disk} target='_blank' className='call-out dark foundation-disk-call-out'>
              <span className='title'>Haemongyang</span>
              <span className='title'>—Hyoo</span>
              <span className='title'>—Buy</span>
            </a>
          </div>
        </div>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('burger')} className={burgerClassNames}>
            <span className='title'>Burger</span>
            <span className='subtitle'>—LO-FI</span>
            <span className='more-info'>LA</span>
            <span className='onair'>—on air</span>
          </a>

          <div className='burger-hat-container'>
            <div className='burger-hat-image'>
              <a href={productLinks.burger.hat[territory]} target='_blank'><img src={burgerHat} width='552' /></a>
            </div>
            <a href={productLinks.burger.hat[territory]} target='_blank' className='call-out dark burger-hat-call-out'>
              <span className='title'>Tropic Ventair</span>
              <span className='title'>Spacecap</span>
              <span className='title'>mARINE</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='burger-disk-container'>
            <div className='burger-disk-image'>
              <a href={productLinks.burger.disk} target='_blank'><img src={burgerDisk} width='335' /></a>
            </div>
            <a href={productLinks.burger.disk} target='_blank' className='call-out dark burger-disk-call-out'>
              <span className='title'>brain cream—</span>
              <span className='title'>jail</span>
              <span className='title'>—Buy</span>
            </a>
          </div>
        </div>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('stones-throw')} className={stonesThrowClassNames}>
            <span className='title'>Stones Throw</span>
            <span className='subtitle'>—Hip-Hop</span>
            <span className='more-info'>LA</span>
            <span className='onair'>—on air</span>
          </a>

          <div className='stones-throw-hat-container'>
            <div className='stones-throw-hat-image'>
              <a href={productLinks['stones-throw'].hat[territory]} target='_blank'><img src={stonesThrowHat} width='552' /></a>
            </div>
            <a href={productLinks['stones-throw'].hat[territory]} target='_blank' className='call-out dark stones-throw-hat-call-out'>
              <span className='title'>Bermuda</span>
              <span className='title'>Casual WHITE</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='stones-throw-disk-container'>
            <div className='stones-throw-disk-image'>
              <a href={productLinks['stones-throw'].disk} target='_blank'><img src={stonesThrowDisk} width='335' /></a>
            </div>
            <a href={productLinks['stones-throw'].disk} target='_blank' className='call-out dark stones-throw-disk-call-out'>
              <span className='title'>yawn zen</span>
              <span className='title'>—mndsgn</span>
              <span className='title'>—Buy</span>
            </a>
          </div>
        </div>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('workshop')} className={workshopClassNames}>
            <span className='title'>Workshop</span>
            <span className='subtitle'>—Techno</span>
            <span className='more-info'>Berlin</span>
            <span className='onair'>—on air</span>
          </a>

          <div className='workshop-hat-container'>
            <div className='workshop-hat-image'>
              <a href={productLinks.workshop.hat[territory]} target='_blank'><img src={workshopHat} width='552' /></a>
            </div>
            <a href={productLinks.workshop.hat[territory]} target='_blank' className='call-out dark workshop-hat-call-out'>
              <span className='title'>Tropic Hardee</span>
              <span className='title'>BLACK</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='workshop-disk-container'>
            <div className='workshop-disk-image'>
              <a href={productLinks.workshop.disk} target='_blank'><img src={workshopDisk} width='335' /></a>
            </div>
            <a href={productLinks.workshop.disk} target='_blank' className='call-out dark workshop-disk-call-out'>
              <span className='title'>WORKSHOP 02</span>
              <span className='title'>—Move D feat.</span>
              <span className='title'>DJ Late</span>
              <span className='title'>—Buy</span>
            </a>
          </div>
        </div>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('minimal-wave')} className={minimalWaveClassNames}>
            <span className='title'>Minimal Wave</span>
            <span className='subtitle'>—Synth</span>
            <span className='more-info'>NYC</span>
            <span className='onair'>—on air</span>
          </a>

          <div className='minimal-wave-hat-container'>
            <div className='minimal-wave-hat-image'>
              <a href={productLinks['minimal-wave'].hat[territory]} target='_blank'><img src={minimalWaveHat} width='552' /></a>
            </div>
            <a href={productLinks['minimal-wave'].hat[territory]} target='_blank' className='call-out dark minimal-wave-hat-call-out'>
              <span className='title'>Bamboo</span>
              <span className='title'>Mowbray</span>
              <span className='title'>BLACK</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='minimal-wave-disk-container'>
            <div className='minimal-wave-disk-image'>
              <a href={productLinks['minimal-wave'].disk} target='_blank'><img src={minimalWaveDisk} width='335' /></a>
            </div>
            <a href={productLinks['minimal-wave'].disk} target='_blank' className='call-out dark minimal-wave-disk-call-out'>
              <span className='title'>H.S.T.A.—</span>
              <span className='title'>DAS DING</span>
              <span className='title'>—Buy</span>
            </a>
          </div>
        </div>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('plant')} className={plantClassNames}>
            <span className='title'>Plant Records</span>
            <span className='subtitle'>—Hip-Hop</span>
            <span className='more-info'>Osaka</span>
            <span className='onair'>—on air</span>
          </a>

          <div className='plant-hat-container'>
            <div className='plant-hat-image'>
              <a href={productLinks.plant.hat[territory]} target='_blank'><img src={plantHat} width='552' /></a>
            </div>
            <a href={productLinks.plant.hat[territory]} target='_blank' className='call-out dark plant-hat-call-out'>
              <span className='title'>BAMBOO</span>
              <span className='title'>SPACECAP</span>
              <span className='title'>SERGEANT</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='plant-disk-container'>
            <div className='plant-disk-image'>
              <a href={productLinks.plant.disk} target='_blank'><img src={plantDisk} width='335' /></a>
            </div>
            <a href={productLinks.plant.disk} target='_blank' className='call-out dark plant-disk-call-out'>
              <span className='title'>Useful For</span>
              <span className='title'>Mind—dj yasa</span>
              <span className='title'>Pablo—Buy</span>
            </a>
          </div>
        </div>
        <div className='shop-panel' style={panelStyle}>
          <a href='#' onClick={this.createCallClick('soundway')} className={soundwayClassNames}>
            <span className='title'>Soundway</span>
            <span className='subtitle'>—Global Dance</span>
            <span className='more-info'>London</span>
            <span className='onair'>—on air</span>
          </a>

          <div className='soundway-hat-container'>
            <div className='soundway-hat-image'>
              <a href={productLinks.soundway.hat[territory]} target='_blank'><img src={soundwayHat} width='552' /></a>
            </div>
            <a href={productLinks.soundway.hat[territory]} target='_blank' className='call-out dark soundway-hat-call-out'>
              <span className='title'>British Peebles</span>
              <span className='title'>TAN</span>
              <span className='title'>—Buy</span>
            </a>
          </div>

          <div className='soundway-disk-container'>
            <div className='soundway-disk-image'>
              <a href={productLinks.soundway.disk} target='_blank'><img src={soundwayDisk} width='335' /></a>
            </div>
            <a href={productLinks.soundway.disk} target='_blank' className='call-out dark soundway-disk-call-out'>
              <span className='title'>Sierra Leone in</span>
              <span className='title'>1970s USA —</span>
              <span className='title'>Muyei Power</span>
              <span className='title'>—Buy</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/routes/Shop.jsx
 **/